import mixpanel, { Config } from 'mixpanel-browser';
import { Environment } from '../enums/env';

export function enableMixPanel(): boolean {
  return process.env.REACT_APP_ENV === Environment.Production || process.env.REACT_APP_ENV === Environment.QA;
}

export function initMixPanel(): void { // set debug to true to emit debug console messages
  mixpanel.init(process.env.REACT_APP_MIXPANEL_PROJECT_TOKEN, { debug: false, ignore_dnt: true, opt_out_tracking_by_default: false } as Partial<Config>);
}

const Mixpanel = {
  track: (name: string, props: any) => {
    if (enableMixPanel()) {
      try {
        mixpanel.track(name, { ...props, environment: process.env.REACT_APP_ENV });
      } catch (e) {
        // what should we do when tracking fails?
      }
    }
  },
};

export default Mixpanel;
